import React from 'react';

interface DataItem {
  label: string;
  value: number;
  color: string;
}

interface SimplePieChartProps {
  data: DataItem[];
  size?: number;
}

const SimplePieChart: React.FC<SimplePieChartProps> = ({ data, size = 200 }) => {
  const total = data.reduce((acc, item) => acc + item.value, 0);
  let cumulativeValue = 0;

  const getCoordinatesForPercent = (percent: number) => {
    const x = Math.cos(2 * Math.PI * percent);
    const y = Math.sin(2 * Math.PI * percent);
    return [x, y];
  };

  if (total === 0) {
    return (
      <div style={{ width: size, height: size, borderRadius: '50%', background: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999', fontSize: '0.8rem' }}>
        Sem dados
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
      <svg viewBox="-1 -1 2 2" style={{ width: size, height: size, transform: 'rotate(-90deg)' }}>
        {data.map((item, index) => {
          const startPercent = cumulativeValue / total;
          const slicePercent = item.value / total;
          cumulativeValue += item.value;
          const endPercent = cumulativeValue / total;

          const [startX, startY] = getCoordinatesForPercent(startPercent);
          const [endX, endY] = getCoordinatesForPercent(endPercent);

          const largeArcFlag = slicePercent > 0.5 ? 1 : 0;

          const pathData = [
            `M ${startX} ${startY}`,
            `A 1 1 0 ${largeArcFlag} 1 ${endX} ${endY}`,
            `L 0 0`,
          ].join(' ');

          return (
            <path
              key={index}
              d={pathData}
              fill={item.color}
              stroke="white"
              strokeWidth="0.02"
            />
          );
        })}
      </svg>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {data.map((item, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.9rem' }}>
            <span style={{ width: '12px', height: '12px', borderRadius: '2px', backgroundColor: item.color, display: 'inline-block' }}></span>
            <span style={{ color: 'var(--text-secondary)' }}>{item.label}:</span>
            <span style={{ fontWeight: 'bold' }}>{item.value}</span>
            <span style={{ fontSize: '0.8rem', color: '#999' }}>({Math.round((item.value / total) * 100)}%)</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimplePieChart;
